import { handleChoiceField } from "../../prefill/helpers";
import { FieldRegistryConfig } from "../../types";
import { normalizeReviewReadableValue } from "../review/reviewString.helpers";
import { SingleSelectFieldControl } from "./SingleSelectFieldControl/SingleSelectFieldControl";

export type SingleSelectFieldValue = string;

export const singleSelectFieldConfig: FieldRegistryConfig<SingleSelectFieldValue> = {
  icon: "single-select",
  control: SingleSelectFieldControl,
  prefill: ({ value, field }) => handleChoiceField(value, field.params.choices),
  toReviewString: (value, appField) => {
    const rawValue = normalizeReviewReadableValue(value);
    const matchedChoice = appField.params.choices?.find((choice) => choice.value === rawValue);
    return matchedChoice?.label ?? rawValue;
  },
};
